"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../DOM/HTMLElement/Query");
// suppressed for testing purposes. jsdom doesn't have ShadowRoot support
// istanbul ignore next
if (typeof ShadowRoot !== 'undefined') {
    // also make available for ShadowRoot
    ShadowRoot.prototype.query = HTMLElement.prototype.query;
    ShadowRoot.prototype.queryPromise = HTMLElement.prototype.queryPromise;
    ShadowRoot.prototype.queryRole = HTMLElement.prototype.queryRole;
    ShadowRoot.prototype.queryRolePromise = HTMLElement.prototype.queryRolePromise;
    ShadowRoot.prototype.queryRoleAll = HTMLElement.prototype.queryRoleAll;
    ShadowRoot.prototype.queryData = HTMLElement.prototype.queryData;
}
//# sourceMappingURL=ShadowRoot.js.map